<div class="container">
  @if (withLabel) {
    <ion-label [ngClass]="baseCssClass">Next step:</ion-label>
  }

  @if (disabled) {
    <rc-order-step-badge [orderNextStep]="fieldValue"></rc-order-step-badge>
  }

  @if (!disabled) {
    <ion-select
      [ngClass]="baseCssClass"
      [value]="fieldValue"
      placeholder="Select a value"
      (ionChange)="onInputChange($event)">
      @for (value of orderStepValues; track value) {
        <ion-select-option [value]="value">
          {{ orderStepToString(value) }}
        </ion-select-option>
      }
    </ion-select>
  }
</div>
